import { useEffect, useMemo } from "react";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import { Tabs, Tab, Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import PasswordGate from "./PasswordGate";
import { loginDevPage } from "../redux/features/auth/authSlice";

function DevPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  //const roles = useSelector((state) => state.auth.roles);
  const unlockedDevPage = useSelector((state) => state.auth.unlockedDevPage);
  const baseMenu = useMemo(
    () => [
      {
        stt: 0,
        text: "API HÓA ĐƠN",
        path: "/dev/api-hoa-don",
        pageNo: "InvoiceSupplierConnectionPage",
      },
      {
        stt: 1,
        text: "HTTT",
        path: "/dev/hinh-thuc-thanh-toan",
        pageNo: "PaymentMethodPage",
      },
    ],
    []
  );

  const menuItems = useMemo(() => {
    return baseMenu;
  }, [baseMenu]);

  const tabValue = useMemo(() => {
    const found = menuItems.find(
      (m) =>
        location.pathname === m.path ||
        (m.path !== "/" && location.pathname.startsWith(m.path + "/"))
    );
    return found?.stt ?? menuItems[0]?.stt ?? 0;
  }, [location.pathname, menuItems]);

  const handleChangeTab = (_e, newValue) => {
    const target = menuItems.find((m) => m.stt === newValue);
    if (target) navigate(target.path);
  };

  useEffect(() => {
    if (location.pathname === "/dev") {
      const first = menuItems[0];
      if (first) navigate(first.path, { replace: true });
    }
  }, [location.pathname, menuItems, navigate]);

  const handleUnlocked = () => {
    dispatch(loginDevPage());
  };

  if (unlockedDevPage !== "1") {
    return <PasswordGate onSuccess={handleUnlocked} />;
  }

  return (
    <Box
      sx={{
        flexGrow: 1,
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Tabs
        value={tabValue}
        onChange={handleChangeTab}
        indicatorColor="primary"
        textColor="primary"
        selectionFollowsFocus
        variant="scrollable"
        allowScrollButtonsMobile
      >
        {menuItems.map((item) => (
          <Tab key={item.path} label={item.text} value={item.stt} />
        ))}
      </Tabs>

      <Box
        sx={{
          flexGrow: 1,
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "auto",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}

export default DevPage;
